function Trustee() {
  return (
    <div className="pt-16 px-4 md:px-8 lg:px-16 max-w-5xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center md:text-left">
        विश्वस्त मंडळ ट्रस्टी
      </h2>
      <p className="text-gray-700 text-base md:text-lg leading-relaxed">
        {/* <b>ट्रस्टचे कार्य पारदर्शकता प्रामाणिकपणा व भक्ती भवाने चालवले जाते:</b> */}
        <b>
          श्री सुयोग गणेश महाडिक (संस्थापक मुख्य विश्वस्त) <br />
        </b>
        <b>श्री चंद्रकांत रतिलाल व्यास (व्यवस्थापक विश्वस्त)</b>
        <br />
        <b> श्री राजू अनंत तावडे (व्यवस्थापक विश्वस्त)</b>
        <br />
        <b> श्री वासुदेव यशवंत वस्त (व्यवस्थापक विश्वस्त)</b>
        <br /> <b>श्री अरविंद दगडू मोरे (व्यवस्थापक विश्वस्त)</b>
        <br /> <b>श्री बापू बबन कोळपे (व्यवस्थापक विश्वस्त)</b>
        <br /> <b>श्री राजेंद्र मनोहर पाताडे(उपखजिनदार)</b>
        <br />
      </p>
    </div>
  );
}

export default Trustee;
